import React, { useEffect, useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '@app/utils/httpProvider';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import {
    messageError,
    messageToast,
    status200,
} from '../../../utils/define';
import { BaseGatewayImage, LOCATIONS_API, TIMESLOTS_API } from '../../../utils/apiUrl';
import ReactSpinner from '../../../components/reactSpinner/ReactSpinner';

const LocationsTimeSlots = () => {
    const [isLoadingEdit, setIsLoadingEdit] = useState(false);
    const [mergedTimeSlotsState, setMergedTimeSlotsState] = useState([]);
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const id = paramUrl.get('id');

    // Lây tất cả Khung giờ trong hệ thống
    const { isLoading: isLoadingAllTime, isError: isErrorAllTime, error: errorAllTime, data: dataAllTime } = useQuery(
        ['dataAllTime'],
        async () => {
            const response = await Get(TIMESLOTS_API.GET_ALL_PAGING, null, {
                PageIndex: 1,
                PageSize: 100,
                IsActive: true
            });
            return response;
        }
    );

    // Lấy thông tin Location
    const { isLoading: isLoadingILo, isError: isErrorILo, error: errorILo, data: dataILo } = useQuery(
        ["locationItem", id], // Thay đổi queryKey để tránh trùng lặp
        () => Get(LOCATIONS_API.GET_BY_ID, id)
    );

    // Lấy các khung giờ đã có thuộc về ID
    const { isLoading: isLoadingdata, isError: isErrordata, error: errordata, data: dataTimeSOfLo } = useQuery(
        ["timeslotOfLo", id], // Query key khác với query trên
        () => Get(LOCATIONS_API.GET_ALL_TIMESLOTS_BY_DATE_LOCATION, null, { locationId: id })
    );

    const mergeTimeSlots = (dataAllTime, dataTimeSOfLo) => {
        if (!dataAllTime || !dataTimeSOfLo) return [];
        // Chuyển dataTimeSOfLo thành Map để tra cứu nhanh hơn
        const timeSlotMap = new Map(
            dataTimeSOfLo?.$values?.map(item => [item.timeId, item])
        );

        // Duyệt qua dataAllTime và kết hợp dữ liệu
        const mergedData = dataAllTime?.data?.$values.map(item => {
            const matchedSlot = timeSlotMap.get(item.id);

            return {
                ...item,
                isSelected: !!matchedSlot, // Nếu tồn tại trong dataTimeSOfLo thì true
                maxSlot: matchedSlot ? matchedSlot.maxSlot : 0 // Giữ maxSlot nếu có
            };
        });
        return mergedData;
    };


    useEffect(() => {
        if (dataAllTime && dataTimeSOfLo) {
            console.log("dataAllTime", dataAllTime);

            const mergedTimeSlots = mergeTimeSlots(dataAllTime, dataTimeSOfLo);
            setMergedTimeSlotsState(mergedTimeSlots);
        }
    }, [dataAllTime, dataTimeSOfLo]); // 🔥 Thêm dependency



    const editFuncLocationTimeSlots = useMutation((model) =>
        Post(LOCATIONS_API.ASSIGN_TIMESLOTS, null, model)
    );

    const handleEdit = async () => {
        try {
            const formattedTimeSlots = mergedTimeSlotsState
                .filter(item => item.isSelected) // 🔍 Chỉ lấy phần tử có isSelected = true
                .map(item => ({
                    "timeslotId": item.id,
                    "maxSlot": item.maxSlot
                }));
            const modelUpdate = {
                "locationId": id,
                "timeslots": formattedTimeSlots
            }
            editFuncLocationTimeSlots.mutate(modelUpdate, {
                onSuccess: (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastUpdateError);
                    } else {
                        toast.success(messageToast.messageToastUpdateSuccess);
                    }
                },
                onError: (res) => {
                    toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
                }
            });
        }
        catch (error) {
            toast.error("Có lỗi xảy ra khi xóa!");
        }

    };

    // Xử lý thay đổi chon/ bỏ chọn khung giờ
    const toggleSelection = (id) => {
        const updatedSlots = mergedTimeSlotsState.map(item =>
            item.id === id ? { ...item, isSelected: !item.isSelected } : item
        );
        setMergedTimeSlotsState(updatedSlots);
    };

    // Xử lý thay đổi maxSlot
    const updateMaxSlot = (id, newMaxSlot) => {
        const updatedSlots = mergedTimeSlotsState.map(item =>
            item.id === id ? { ...item, maxSlot: Number(newMaxSlot) } : item
        );
        setMergedTimeSlotsState(updatedSlots);
    };

    return (
        <Card>
            <Card.Header as="h3">Cập nhật thông tin khung giờ cho cơ sở spa :  {dataILo && dataILo.name ? dataILo.name : ''}</Card.Header>
            <Card.Body>
                {isLoadingAllTime ? (
                    <div>Loading...</div>
                ) : isErrorAllTime ? (
                    <div>An error has occurred: ${errorAllTime.message}</div>
                ) : dataAllTime == null ? (
                    <div></div>
                ) : (
                    <div>
                        {mergedTimeSlotsState.length === 0 ? (
                            <div>Không có dữ liệu</div>
                        ) : (
                            <div>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                    {mergedTimeSlotsState.map(item => (
                                        <div
                                            key={item.id}
                                            style={{
                                                padding: "10px",
                                                // border: "1px solid #ccc",
                                                borderRadius: "5px",
                                                backgroundColor: item.isSelected ? "#28a745" : "orange",
                                                color: item.isSelected ? "#fff" : "#000",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                width: "auto"
                                            }}
                                        >
                                            <button style={{ padding: '15px', cursor: 'pointer' ,border: "1px solid #ccc"  }} onClick={() => toggleSelection(item.id)}>
                                                {item.time}
                                            </button>
                                            <div>
                                                <span>Slost Tối đa: </span>
                                                <input
                                                    type="number"
                                                    value={item.maxSlot}
                                                    onChange={(e) => updateMaxSlot(item.id, e.target.value)}
                                                    disabled={!item.isSelected} // Chỉ cho chỉnh sửa khi được chọn
                                                    style={{
                                                        width: "50px",
                                                        textAlign: "center",
                                                        marginTop: "5px",
                                                        border: "1px solid #ccc",
                                                        backgroundColor: item.isSelected ? "#fff" : "#ccc"
                                                    }}
                                                />
                                            </div>

                                        </div>
                                    ))}
                                </div>
                                <div className="row">
                                    <div className="d-flex justify-content-between mt-3">
                                        <button
                                            className="btn btn-danger"
                                            onClick={handleEdit}
                                        >
                                            Cập nhật thay đổi
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <ReactSpinner loadings={isLoadingEdit} />
            </Card.Body>
        </Card>
    );
};

export default LocationsTimeSlots;
